"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLitActionCodeOrCid = exports.getLitActionCode = exports.getLitActionCid = exports.postLitActionValidation = void 0;
const code_repository_1 = require("./code-repository");
const constants_1 = require("./constants");
/**
 *
 * Post processes the Lit Action result to ensure that the result is non-empty and a valid string
 *
 * @param result - The Lit Action result to be processes
 *
 * @returns { string } - The response field in the Lit Action result object
 */
function postLitActionValidation(result) {
    if (!result) {
        throw new Error('There was an unknown error running the Lit Action.');
    }
    const { response } = result;
    if (!response) {
        throw new Error(`Expected "response" in Lit Action result: ${JSON.stringify(result)}`);
    }
    if (typeof response !== 'string') {
        // As the return value is a hex string
        throw new Error(`Lit Action should return a string response: ${JSON.stringify(result)}`);
    }
    if (!result.success) {
        throw new Error(`Expected "success" in res: ${JSON.stringify(result)}`);
    }
    if (response.startsWith('Error:')) {
        // Lit Action sets an error response
        throw new Error(`Error executing the Signing Lit Action: ${response}`);
    }
    return response;
}
exports.postLitActionValidation = postLitActionValidation;
function getLitActionCid(network, actionType) {
    // We already have guarantees that `actionType` is valid; it is not user provided and type-safe
    assertNetworkIsValid(network);
    return constants_1.LIT_ACTION_CID_REPOSITORY[actionType][network];
}
exports.getLitActionCid = getLitActionCid;
function getLitActionCode(network, actionType) {
    // We already have guarantees that `actionType` is valid; it is not user provided and type-safe
    assertNetworkIsValid(network);
    // No fuzzy validation needed here, because `setLitActionsCode()` validates its input
    return code_repository_1.litActionCodeRepository[actionType][network];
}
exports.getLitActionCode = getLitActionCode;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function assertNetworkIsValid(network) {
    const validNetworks = ['evm', 'solana'];
    if (!validNetworks.includes(network)) {
        throw new Error(`Invalid network: ${network}. Must be one of ${validNetworks.join(', ')}.`);
    }
}
/**
 * Fetch the Lit action code or its IPFS CID for a given network and action type.
 *
 * @param {Network} network The network to get the code or CID for.
 * @param {LitActionType} actionType The type of action to get the code or CID for.
 * @returns {{ litActionCode?: string, litActionIpfsCid?: string }} The Lit action code or its IPFS CID.
 */
function getLitActionCodeOrCid(network, actionType) {
    // Default state is that litActionCode will be falsy, unless someone has injected to it using `setLitActionsCode();
    const litActionCode = getLitActionCode(network, actionType);
    if (litActionCode) {
        return { litActionCode };
    }
    return { litActionIpfsCid: getLitActionCid(network, actionType) };
}
exports.getLitActionCodeOrCid = getLitActionCodeOrCid;
//# sourceMappingURL=utils.js.map